import RaisedButton from '@mui/material/Button';
import DoNotDisturbIcon from '@mui/icons-material/RemoveCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import React, { useMemo } from 'react';

import Empty from 'components/Empty';

export default () => (
  <Empty
    buttons={useMemo(
      () => (
        <RaisedButton
          startIcon={<RefreshIcon />}
          onClick={() => {
            if (window) {
              window.location.replace('/');
            }
          }}
          primary
        >
          Start Over
        </RaisedButton>
      ),
      [],
    )}
    icon={useMemo(
      () => (
        <DoNotDisturbIcon
          style={{
            width: 100,
            height: 100,
            color: '#FF495F',
          }}
        />
      ),
      [],
    )}
    style={useMemo(
      () => ({ height: '100vh' }),
      [],
    )}
    title='We couldn&apos;t find that page!'
  />
);
